import { useEffect, useState } from "react";

import SubMerchantService from "@/services/subMerchantService";
import UserService from "@/services/userService";

import useAuthStore from "@/stores/useAuthStore";

/**
 * EPS-5027 — Ana bayi, alt bayilerinin satış ve planlarını da listeler. Liste birden fazla
 * bayinin kaydını içerdiği için satırın hangi bayiye ait olduğu gösterilir.
 *
 * Alt bayisi olmayan merchant'ta (ve alt bayi kullanıcısında) kolon hiç açılmaz: liste zaten
 * tek bayinin kayıtlarından oluşur.
 */
export const useSubMerchantTitles = () => {
  const user = useAuthStore((state) => state.user);
  const [titles, setTitles] = useState(null);

  useEffect(() => {
    if (user?.type !== "ADMIN") return;

    let cancelled = false;

    SubMerchantService.getSubMerchants()
      .then(async (subMerchants) => {
        if (cancelled || !subMerchants.length) return;

        const merchant = await UserService.getMerchantData().catch(() => null);
        if (cancelled) return;

        setTitles({
          ...Object.fromEntries(
            subMerchants.map((subMerchant) => [
              subMerchant.id,
              subMerchant.title,
            ]),
          ),
          ...(merchant?.id ? { [merchant.id]: merchant.title } : {}),
        });
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [user?.type]);

  return {
    showMerchantColumn: Boolean(titles),
    getMerchantTitle: (merchantId) => titles?.[merchantId] ?? "-",
  };
};

export default useSubMerchantTitles;
